<template>
    <div class="row">
        <div class="col-xl-12 col-lg-12">
            <div class="card azure">
                <div class="card-header">
                    <div class="basic-form" style="width:100%">
                        <div class="form-row">
                            <div class="form-group col-sm-4">
                                <label>Idioma:</label>
                                <select class="form-control" v-model="hotelPortalEditado.idioma">
                                    <template v-if="idiomas && idiomas.length > 0">
                                        <option v-for="idioma in idiomas" v-bind:key="idioma.ididioma"
                                            :value="idioma.codidioma"
                                            :selected="hotelPortalEditado.idioma==idioma.codidioma">{{idioma.descidioma}}
                                        </option>
                                    </template>
                                </select>
                            </div>
                            <div class="form-group col-sm-8">
                                <label>Nome:</label>
                                <input v-model="hotelPortalEditado.nome" 
                                    type="text" class="form-control" placeholder="Nome do portal">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-8">
                                <label>Link:</label>
                                <input v-model="hotelPortalEditado.link" 
                                    type="text" class="form-control" placeholder="Link do portal">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-12">
                                <label>Ponto limite:</label>
                                <input v-model="hotelPortalEditado.pontolimite" 
                                    type="number" class="form-control" placeholder="Ponto limite, a partir do qual o link do portal aparece">
                            </div>
                        </div>
                        <!-- Imagem -->
                        <div v-if="hotelPortalEditado.idhotelportal>0" class="form-group col-sm-auto">
                            <label>Imagem:</label>
                            <div class="imagem-promocao">
                                <label class="ponteiro" :for="'file_'+hotelPortalEditado.idhotelportal">
                                    <div v-if="!imagemSrc"><span class="material-icons icon">reviews</span></div>
                                    <img v-if="imagemSrc" :src="'data:' + hotelPortalEditado.tipoImg + ';base64,' + imagemSrc" 
                                        :id="'imgPromo_'+hotelPortalEditado.idhotelportal"
                                    />
                                </label>
                                <input @change="onFileChange" type="file" :id="'file_'+hotelPortalEditado.idhotelportal" 
                                    :name="'file_'+hotelPortalEditado.idhotelportal" accept="image/png,image/jpg,image/jpeg" 
                                    class="ponteiro" style="display:none;">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-sm-auto">
                                <a v-on:click="$emit('save',hotelPortalEditado)" class="ponteiro text-white btn btn-info mt-4">Salvar</a>
                            </div>
                            <div class="form-group col-sm-auto">
                                <a v-on:click="$emit('close')" class="ponteiro text-white btn btn-info mt-4">Fechar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import CONSTANTS from '../constants'
import { serializarImagem } from '../utils/serializar'
export default {
    props: {
        hotelPortal: {
            type: Object,
            required: true,
        }
    },    
    data() {
        return {
            idiomas: [],
            headers: {
                'x-access-token': this.$store.getters.GetLoginInfo.token
            },
            hotelPortalEditado: {},
            imagemSrc: null,    
            tipoImg: null
        }
    },
    methods: {
        onFileChange(e) {
            serializarImagem(e, 0.5).then(resp =>{
                this.imagemSrc = resp.dados
                this.tipoImg = resp.tipo
                if (this.hotelPortalEditado.idhotelportal > 0) {
                    this.salvarImagem(resp.tipo);
                }
            }).catch(er =>{
                console.error(er)
            })
        },        
        salvarImagem(tipoImg) {
            if (!this.imagemSrc.length > 0) {
                console.error("Imagem inválida!");
                return;
            }
            var params = {
                "tipo" : tipoImg,
                "nome" : "Imagem_Cidade_Sobre_"+this.hotelPortalEditado.idhotelportal,
                "dados" : this.imagemSrc,
                "tabela": "hotelportal",
                "fk": "imagem",
                "chave": "idhotelportal",
                "valor": this.hotelPortalEditado.idhotelportal,
                "idusuario": this.$store.getters.GetLoginInfo.idusuario,
                "deleteold": false
            }
            //console.error(JSON.stringify(params))
            axios.post(CONSTANTS.API_URL + '/fdguest/imagem/upinsert'
                    ,params, { timeout:60000, headers: this.headers })
                .then((response) => {
                    if(response.status == 200){
                        this.hotelPortalEditado.imagem = response.data.result.imagem[0]
                        console.log('response.data:'+response.data)
                    }else{
                        console.log(JSON.stringify(response))
                    }
                })
                .catch((error) => {
                    console.log(error.response);
            });
        },
		carregarImagem() {
            if (this.hotelPortalEditado.imagem) {
                this.imagemSrc = null
                this.tipoImg = null
                axios.post(CONSTANTS.API_URL + '/fdguest/imagem/select', 
                    { id: this.hotelPortalEditado.imagem }, { headers: this.headers })
                .then((response) => {
                    if (response.status == 200) {
                        var imgObj = response.data[0]
                        if (imgObj) {
                            this.imagemSrc = Buffer.from(imgObj.dados).toString()
                            this.tipoImg = imgObj.tipo
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
            }
		},        
        loadIdiomas() {
			axios.post(CONSTANTS.API_URL + '/fdguest/idiomas/suportados', {
				tipo: "U",
				idusuario: this.$store.getters.GetLoginInfo.idusuario
			}, {headers: this.headers})
			.then(response => {
				try {
					if (response.status == 200) {
						if (response.data) {
							this.idiomas = response.data;
						}
					}
				}
				catch(e) {
					console.log(e);
				}
			}).catch((err) => {
				console.log({ err_menu: err });
			});
        }
    },
    computed: {
    },
    beforeMount() {
        this.loadIdiomas();
    },
    mounted() {
        this.hotelPortalEditado = {... this.hotelPortal}
        this.carregarImagem()
    }
}
</script>

<style scoped>
.azure {
    background-color: azure!important;
}
.material-icons {
    font-family: 'Material Icons';
    font-size: 30px;
}
</style>